var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: "File Information",
        centered: "",
        "ok-only": "",
        "ok-title": "Close",
        "ok-variant": "outline-primary",
        "auto-focus-button": "ok",
        size: "lg",
      },
      on: { hide: _vm.closeHandler },
    },
    [
      _vm.firstSelectedItem
        ? _c(
            "div",
            [
              _c("b-table", { attrs: { items: _vm.fileInfo } }),
              _vm._v(" "),
              _vm.hasMetaproperties
                ? _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mb-2 d-block mx-auto",
                          attrs: { variant: "outline-primary" },
                          on: { click: _vm.toggleMetaproperties },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.showMetaproperties
                                  ? "Hide Metaproperties"
                                  : "Show Metaproperties"
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("MetapropertiesTable", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMetaproperties,
                            expression: "showMetaproperties",
                          },
                        ],
                        attrs: {
                          metaproperties: _vm.firstSelectedItem.metaproperties,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c("b-spinner"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }